/**
 * Dev API Testing Page
 * Simple OpenAPI-driven API testing interface
 */

import { useEffect } from 'react'
import { makeStyles, tokens, Caption1 } from '@fluentui/react-components'
import { useSetHeaderLeft } from '../../components'
import { RequestTester } from './components'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    flex: 1,
  },
  content: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: tokens.spacingVerticalXXS,
  },
  title: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase400,
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
  },
})

function HeaderContent() {
  const styles = useStyles()
  return (
    <div className={styles.headerContent}>
      <span className={styles.title}>API Testing</span>
      <Caption1 className={styles.subtitle}>Send requests and view responses</Caption1>
    </div>
  )
}

export function DevApiPage() {
  const styles = useStyles()
  const setHeaderLeft = useSetHeaderLeft()

  useEffect(() => {
    setHeaderLeft(<HeaderContent />)
    return () => setHeaderLeft(null)
  }, [setHeaderLeft])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <RequestTester />
      </div>
    </div>
  )
}
